// extracted by mini-css-extract-plugin
export default {"resident-settings__form-label":"ResidentSettings_resident-settings__form-label__EYvIG"};